module.exports = __webpack_public_path__ + "r-v3/img/laser-pointer_off.eb3d2dd8.svg";